export const myCafeteriaTranslationsEn = {
  MY_CAFETERIA_PAGE_TITLE: "My Cafeteria balance and statement",
  MY_CAFETERIA_ACTIVE_HUNGARIANS_BENEFIT_INFO: "Attention! In the case of Active Hungarians, a maximum of HUF 60,000 per calendar half-year can be given as a preferential tax benefit. Anything above this amount is not considered a preferential benefit.",
  MY_CAFETERIA_ADMIN_GUIDE: "MyCafeteria administrator manual",
  MY_CAFETERIA_USER_GUIDE: "MyCafeteria user manual",
  MY_CAFETERIA_CONFIRM_TITLE: "Are you sure to finish the application?",
  MY_CAFETERIA_CONFIRM_TEXT: "After finishing application you cannot add new benefit or edit an existing benefit.",
  MY_CAFETERIA_FINISH_APPLICATION: "Finish application",
  MY_CAFETERIA_DISABLED_APPLICATION_PRINT_BUTTON: "Printing is possible only in the case of a closed declaration",
  MY_CAFETERIA_VBK_DELETE_SUCCEEDED: "The VBK Regulation uploaded!",
  MY_CAFETERIA_VBK_UPLOAD_SUCCEEDED: "The VBK Regulation removed!",
  MY_CAFETERIA_BRUTTO: "Brutto",
  MY_CAFETERIA_NETTO: "Netto",
  MY_CAFETERIA_UPLOADS: "Uploads",
  MY_CAFETERIA_NEW_REGULATION: "New regulation",
  MY_CAFETERIA_BUDGET: "Budget",
  MY_CAFETERIA_ALL_AMOUNT: "All amount",
  MY_CAFETERIA_ALL_COSTS: "All costs",
  MY_CAFETERIA_REMAINS: "Remains",
  MY_CAFETERIA_ORIGIN: "Origin",
  MY_CAFETERIA_BENEFIT: "Benefit",
  MY_CAFETERIA_MONTHS: "Months",
  MY_CAFETERIA_PREVIOUS_BENEFITS: "Previous benefits",
  MY_CAFETERIA_NUMBER_OF_MONTHS: "No. of months",
  MY_CAFETERIA_VALUE_OF_BENEFIT: "Value of benefit",
  MY_CAFETERIA_VBK_REGULATION: "VBK regulation",
  MY_CAFETERIA_NEW_BENEFIT: "New benefit",
  MY_CAFETERIA_ADD_NEW_BENEFIT: "Add new benefit",
  MY_CAFETERIA_EDIT_BENEFIT: "Edit benefit",
  MY_CAFETERIA_START_OF_PERIOD: "Start of period",
  MY_CAFETERIA_END_OF_PERIOD: "End of period",
  MY_CAFETERIA_DATA_FETCHING_ERROR: "An error occured, when the program tried to fetch data from server!",
  MY_CAFETERIA_NET_AMOUNT: "Net amount",
  MY_CAFETERIA_MONTHLY_NET_AMOUNT: "Monthly net amount",
  MY_CAFETERIA_GROSS_AMOUNT: "Gross amount",
  MY_CAFETERIA_BENEFIT_ELEMENT_IS_NOT_DEFINED: "Current benefit element is not available!",
  MY_CAFETERIA_SZEP_STATEMENT: "Statement on the use of the SZÉP card in {{currentYear}}",
  MY_CAFETERIA_VBK_STATEMENT: "Statement on the use of VBK benefits",
  MY_CAFETERIA_TAX_ID_SIGN_ID: "Tax ID sign",
  MY_CAFETERIA_STATEMENT_CONTRACT_CODE: "Registration number",
  MY_CAFETERIA_SUB_ACCOUNTS: "Sub-accounts",
  MY_CAFETERIA_SZEP_STAT_OF_RES:
    "I acknowledge that all liability in connection with the possible falsehood of this statement rests solely with me.",
  MY_CAFETERIA_DATE_OF_SIGN: "Date of signature",
  MY_CAFETERIA_EMPLOYEE_SIGN: "Employee signature",
  MY_CAFETERIA_FOR_THE_EMPLOYER: "For the employer",
  MY_CAFETERIA_STATEINDUP:
    "The declaration must be submitted in two copies, one for the individual and one for the company. The individual is obliged to keep the declaration until the expiry of the limitation period (5 years).",
  MY_CAFETERIA_I_HAVE_NO_BENEFIT:
    "I have not received a benefit from another company for that tax year in the {{currentyear}} tax year.",
  MY_CAFETERIA_SZEP_BENEFIT_NAME:
    "In parallel with my current employment, I have another employment or legal relationship that creates tax liability. Under this concurrent relationship, I receive or expect to receive the following benefit from the other employer in the tax year {{thisYear}}.",
  MY_CAFETERIA_PLAN: "plan",
  MY_CAFETERIA_FACT: "fact",
  MY_CAFETERIA_USED_BENEFIT: "Used benefit",
  MY_CAFETERIA_COPY: "Copy",
  MY_CAFETERIA_BRUTTO_INFO:
    "Due to the rounding performed when calculating the net / gross amounts, the entered amounts may vary by a few HUF.",
  MY_CAFETERIA_MONTHLY_BRUTTO_INFO: "In the case of benefits covering several months, the value included in the total gross amount is the total amount multiplied by the number of months.",
  MY_CAFETERIA_CAFETERIA_PLAN:
    "The gross amount of the allowance marked as a plan is separated from the budget, however, knowing the exact actual amount, the program will calculate with the cost marked as actual.",
  MY_CAFETERIA_SUM_OTHER_BENEFIT:
    "If the benefit comes from several payers, sum them up.",
  MY_CAFETERIA_OUT_OF_BOUNDS: "This amount you exceed the limit!",
  MY_CAFETERIA_MANDATORY_BENEFIT: "Giving the benefit is mandatory!",
  MY_CAFETERIA_MANDATORY_STARTING_MONTH: "The starting month is mandatory!",
  MY_CAFETERIA_MANDATORY_CLOSING_MONTH: "The closing month is mandatory!",
  MY_CAFETERIA_MANDATORY_MONTH: "The month is mandatory!",
  MY_CAFETERIA_MANDATORY_VALUE: "The value is mandatory!",
  MY_CAFETERIA_APPLIED_BENEFIT: "You have already applied for this benefit for this period!",
  MY_CAFETERIA_I_HAVE_BENEFIT:
    "The {{currentyear}} tax year on this sub-account is regulated by a benefit from another company as follows: ",
};
